import React, { useEffect, useRef } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { Autocomplete } from 'irmlib/components/FormControls'
import { userRoleSuperUser } from '../../common/constants'
import PropTypes from 'prop-types'
import { doLogout } from '../../common/functions'
import { YDivider } from 'irmlib/styles'
import { useTranslation } from 'react-i18next'

/**
 * @param {object} props - props pass from UpdateDistrict component
 * @returns {React.ReactElement} - Form dialog for district updation
 */
export const FormDialog = (props) => {
  const { t } = useTranslation()
  const [open, setOpen] = React.useState(false)
  const { role, setDistrict, getDistrict, countryList, districtsList, confirmChangeDistrictOnClick, IsloginWithoutDistrict } = props
  const districtRef = useRef(null)

  useEffect(() => {
    !IsloginWithoutDistrict && handleClickOpen()
  }, [])
  
  const VerticalDivider = () => <YDivider height="20px" />
  
  const handleClickOpen = () => {
    getDistrict()
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    !IsloginWithoutDistrict && doLogout()
  }


  return (
    <React.Fragment>
      {IsloginWithoutDistrict && (<Button variant="contained" size='small' onClick={handleClickOpen}>
        {t('dashBoard.changeDistrictBtn')}
      </Button>)}
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth='xs'>
        <DialogTitle>{ IsloginWithoutDistrict ? t('dashBoard.changeDistrict') : t('dashBoard.districtSelection')}</DialogTitle>
        <DialogContent>
          { role.toUpperCase() === userRoleSuperUser &&
            <Autocomplete
              id={'change_country'}
              label= {t('dashBoard.selectCountry')}
              onChange={(e) => { 
                e !== undefined && getDistrict(e)
                districtRef?.current && (districtRef?.current?.getValue() || districtRef?.current?.getValue() === 0) && districtRef?.current?.setValue('')
              }}
              options={countryList}
              noTranslate
            />}
          <VerticalDivider />
          <Autocomplete
            id={'change_district'}
            label= {t('dashBoard.selectDistrict')}
            onChange={(e) => e !== undefined && setDistrict(e)}
            options={districtsList}
            ref = {districtRef}
            noTranslate
          />
        
        </DialogContent>
        <DialogActions sx={{ pb: 2, pr: 2 }}>
          <Button onClick={handleClose}>{t('buttons.cancel')}</Button>
          <Button variant="contained" onClick={confirmChangeDistrictOnClick}>{t('buttons.save')}</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  )
}

FormDialog.propTypes = {
  role: PropTypes.string.isRequired,
  setDistrict: PropTypes.func,
  getDistrict: PropTypes.func,
  countryList: PropTypes.array,
  districtsList: PropTypes.array,
  confirmChangeDistrictOnClick: PropTypes.func,
  IsloginWithoutDistrict: PropTypes.bool
}